import React from 'react';
import { Box } from '@common-fe/common-fe';

import { BankingBalancePlanBalances } from '@/modules/employer/components/BankingBalance/types';

import BankingBalanceDetailRow from '../BankingBalanceOrgDetails/BankingBalanceDetailRow';

interface Props {
  balances?: BankingBalancePlanBalances;
}

const BankingBalancePlanAdjustments: React.FC<Props> = ({ balances }) => {
  if (!balances) return null;

  return (
    <Box data-testid="plan-adjustments" gap="spacing4">
      <BankingBalanceDetailRow
        testId="plan-adjustments_adjustmentsNotReceived"
        label="Adjustments not received"
        value={balances.adjustmentsNotReceived}
      />
      <BankingBalanceDetailRow
        testId="plan-adjustments_adjustmentsTotalReceived"
        label="Adjustments total received"
        value={balances.adjustmentsTotalReceived}
      />
    </Box>
  );
};

export default BankingBalancePlanAdjustments;
